<template>
  <div class="section-hotlink" id="section-hotlink" data-aos="fade-up" data-aos-once="true" data-aos-offset="-200">
    <div-container>
      <div class="columns is-gapless is-centered" v-if="items && items.length > 0">
        <div v-for="item in items" class="column has-text-centered item-wrapper">
          <a class="item" :href="item.route">
            <img :src="item.image.path" class="img-responsive" nopin="nopin" />
            <div class="banner-wrapper">
              <div class="banner">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </a>
        </div>
        <!-- <div class="column has-text-centered item-wrapper">
          <a class="item" href="/tickets">
            <img src="../assets/menu02.png" class="img-responsive" nopin="nopin" />
            <div class="banner-wrapper">
              <div class="banner">
                <span>BOSS HOG COOK-OFF TICKETS</span>
              </div>
            </div>
          </a>
        </div>
        <div class="column has-text-centered item-wrapper">
          <a class="item" href="/tickets">
            <img src="../assets/menu03.png" class="img-responsive" nopin="nopin" />
            <div class="banner-wrapper">
              <div class="banner">
                <span>EVENTS &amp; SCHEDULE</span>
              </div>
            </div>
          </a>
        </div> -->
      </div>
    </div-container>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
// import ShowDown from 'showdown'

export default {
  name: 'section-hotlink',
  components: {
    DivContainer
  },
  data () {
    return {
      items: [],
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: function (onComplete) {
      this.loading = true
      this.error = undefined
      this.items = []
      Site.hotlink()
      .then((data) => {
        this.loading = false

        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        if (onComplete) {
          onComplete(data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.error(error)
      })
    },
    refresh: function () {
      this.getItems((items) => {
        this.items = items
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section hotlink

.section-hotlink {
  background-color:rgba(0,0,0,0.5);
  background-image: url(../assets/menubg.jpg);
  background-repeat: repeat-y;
  background-position: center;
  background-attachment: fixed;
  margin-bottom: 0;

  @media screen and (min-width: $tablet) {
    margin-bottom: -50px;
  }

  .columns.is-gapless > .column {
    padding: 10px;
  }

  .item-wrapper {
    transform: translate(0, 0);

    @media screen and (min-width: $tablet) {
      transform: translate(0, -90px);
    }

    a.item {
      width: 100%;
      display: inline-block;
      position: relative;

      img {
        width: 100%;
        background-color: $color-gray;
      }

      .banner-wrapper {
        position: absolute;
        bottom: 30px;
        width: 100%;

        .banner {
          margin-left: 30px;
          margin-right: 30px;
          padding: 5px 15px;
          background-color: $color-orange;
          color: black;
          font-family: $font-family-title;
          text-transform: uppercase;
          // font-weight: bold;
          font-size: 1.4em;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// HotlinkSection.vue?56bfe6bd